/**
 * payment 支付相关
 */
import apis from 'src/const/apis';
import * as types from 'src/store/types';
import request from 'src/utils/request';
import { appInfoObect } from 'src/router';
import tool from 'src/utils/tool';
import { paymethodTypeMap } from 'src/const/payment';
import { isDashboardApiOptimizeWhite } from 'src/const/whiteList';
import { EnumAgentRoleAssigned } from 'src/const/agent';
import { accoutType } from 'src/const/account';
import { getAbVersion } from 'src/service/index';

export default {
  namespaced: true,
  state: {
    cardList: [], // 卡组
    cardInfo: {}, // 绑卡信息,
    chargeInfo: {}, // 支付权限
    isChargeInfoLoaded: false,
    // 授信相关
    canDecreaseAmt: false,
    amtOpState: '',
    hasGotChargeInfo: false,
    paymentBalance: {},
    paymentTax: {},
    paymentStatus: {}, // 查看一个广告主是否支付ready(预付费广告主有至少一条充值记录表示支付ready；后付费广告主有绑卡至少一张表示支付ready)
    applyInfo: {
      redirect_url: '',
      status: 0,
      has_permission: true, // 该字段只有自助接口独有，所以默认要设置 true
    },
    thresholdInfo: {
      actual_threshold: '',
      currency: '',
      has_set_manual_threshold: false,
      manual_threshold: '',
      max_threshold: '',
      min_threshold: '',
      threshold_edit_times: 0,
    },
    thresholdWhiteList: true,
    billingShareBanner: {},
    billingOwnInfo: {},
    paymentSummaryReload: null,
    balanceOptimization: {
      new_version: false,
    },
    creditInfo: {}, // 账单信息
  },
  mutations: {
    [types.SET_CREDIT_CARD](state, cards) {
      state.cardList = cards;
    },
    [types.SET_CARD_INFO](state, card) {
      state.cardInfo = card;
    },
    [types.SET_CHARGE_INFO](state, data) {
      state.chargeInfo = data;
      state.isChargeInfoLoaded = true;
    },
    [types.SET_HAS_GOT_CHARGE_INFO](state) { // 获取到了支付信息，用于通知其他依赖支付信息的页面
      state.hasGotChargeInfo = true;
    },
    [types.SET_PAYMENT_BALANCE](state, data) { // 充值余额信息，包含赠款
      state.paymentBalance = data;
    },
    [types.SET_PAYMENT_TAX](state, data) { // 充值计税税务信息
      state.paymentTax = data;
    },
    // 授信相关
    [types.SET_CAN_DECREASE_AMT](state, canDecrease) {
      state.canDecreaseAmt = canDecrease;
    },
    [types.SET_AMT_OP_STATE](state, opState) {
      state.amtOpState = opState;
    },
    [types.SET_PAYMENT_STATUS](state, paymentStatus) {
      state.paymentStatus = paymentStatus;
    },
    [types.SET_PAYMENT_APPLYINFO](state, data) {
      state.applyInfo = {
        ...state.applyInfo,
        ...data,
      };
    },
    [types.SET_THRESHOLD_INF0](state, thresholdInfo) {
      state.thresholdInfo = thresholdInfo;
    },
    [types.SET_THRESHOLD_WHITE_LIST](state, thresholdWhiteList) {
      state.thresholdWhiteList = thresholdWhiteList;
    },
    [types.SET_BILLING_SHARE_BANNER](state, data) {
      state.billingShareBanner = data;
    },
    [types.SET_BILLING_SETTING](state, data) {
      state.billingShareBanner.billing_setting = data;
    },
    [types.SET_BILLING_OWN_INFO](state, data) {
      state.billingOwnInfo = data;
    },
    [types.SET_PAYMENT_SUMMARY_RELOAD](state, fn) {
      state.paymentSummaryReload = fn;
    },
    [types.SET_BALANCE_OPTIMIZATION](state, data) {
      state.balanceOptimization = data;
    },
    [types.SET_CREDIT_INFO](state, data) {
      state.creditInfo = data;
    },
  },
  getters: {
    canNotPayReason: state => state.chargeInfo.can_not_pay_reason || '',
    isChargeInfoLoaded: state => state.isChargeInfoLoaded,
    hasContract: state => !!state.chargeInfo.has_contract,
    hasPayment: state => !!state.chargeInfo.has_payment,
    paymentReady: state => state.paymentStatus.payment_ready,
    paymethod: state => state.chargeInfo.paymethod,
    isCreditUser: state => state.chargeInfo.paymethod === +paymethodTypeMap.CREDIT, // 是否信用卡后付费用户
    isCreditline: state => state.chargeInfo.paymethod === +paymethodTypeMap.CREDIT_LINE, //  授信用户
    taxType: state => state.chargeInfo.tax_type, // -1 未打标， 0消耗计税 1 充值计税
    isShowBalanceTip: (state) => {
      const { tax_type = '-1' } = state.chargeInfo;
      return `${tax_type}` === '0' || `${tax_type}` === '1';// 发现有null存在，并且不确定返回值类型，Number(null) === 0 为 true 改为字符串判断
    },
    // 授信相关
    canAmtDialogConfirm: state => state.amtOpState === 'increase' || state.canDecreaseAmt,
    // 是否展示编辑Threshold入口的角色 --- admin权限 & 内部员工的admin账号
    canEditThresholdRole(state, getters, rootState, rootGetters) {
      const { permissionData } = rootState.account;
      return (
        permissionData?.permission?.ref_role === EnumAgentRoleAssigned.ADMIN || permissionData?.permission?.is_admin
      ) &&
      rootState.account.accountStatus === accoutType.STATUS_ENABLE;
    },
    // Threshold
    thresholdMaxEqlMin(state) {
      return state.thresholdInfo.max_threshold === state.thresholdInfo.min_threshold;
    },
    // managedByBc && bc_id && 有bc 的finance && 非虚客下，展示bc的提示或者 充值跳转到bc
    managedByBCAndHasFinance(state, getters, rootState, rootGetters) {
      const isManagedByBc = state.billingOwnInfo?.billing_managed_by_bc;
      const isBcFinanceEditor = state.billingOwnInfo?.is_billing_bc_finance_editor;
      return isManagedByBc && state.billingOwnInfo?.bc_id && isBcFinanceEditor && !(rootGetters['account/isVirtualAccount']);
    },
    // managedByBc 以下情况下，隐藏充值及卡管理的的判断标志
    // 1. 非managedByBc && billing setting 是在switch
    // 2. managedByBc && 没有bc 的finance
    // 3. managedByBc && 没有bc_id
    // 4. managedByBc && bc_id && 有bc 的finance
    managedByBcHideFunction(state, getters, rootState, rootGetters) {
      const isManagedByBc = state.billingOwnInfo?.billing_managed_by_bc;
      const isBcFinanceEditor = state.billingOwnInfo?.is_billing_bc_finance_editor;
      const isBillingSwitching = !isManagedByBc && state.billingOwnInfo?.is_in_billing_switching;
      const notHasBcFinanceEditor = isManagedByBc && !isBcFinanceEditor;
      const notHasBcId = isManagedByBc && !state.billingOwnInfo?.bc_id;
      const managedByBcAndIsVirtualAccount = isManagedByBc && state.billingOwnInfo?.bc_id && isBcFinanceEditor;
      return isBillingSwitching || notHasBcFinanceEditor || notHasBcId || managedByBcAndIsVirtualAccount;
    },
  },
  actions: {
    // 信用卡后付款相关
    bindCard(store, data) {
      return request.post(apis.payment.bindCard, data);
    },
    payNow(store, data) {
      return request.post(apis.payment.payNow, data);// 手动支付 POST
    },
    // 获取支付失败账单 upay 链接
    getPayNowLink(store, data) {
      return request.get(apis.payment.getPayNowLink, data);// GET upay sdk url
    },
    async getCardInfo({ commit }) {
      const { data } = await request.get(apis.payment.cardInfo);// 获取绑卡信息
      commit(types.SET_CARD_INFO, data);
      return data;
    },
    async getCredit({ commit }, data) {
      const res = await request.get(apis.payment.credit, data);// 获取账期
      commit(types.SET_CREDIT_INFO, res?.data || {});
      return res;
    },
    async getDashboardChargeInfo({ commit }) {
      try {
        const api = isDashboardApiOptimizeWhite()
          ? apis.payment.statistics_charge_info
          : apis.payment.charge_info;
        const { data } = await request.get(api);
        commit(types.SET_HAS_GOT_CHARGE_INFO);
        commit(types.SET_CHARGE_INFO, data);
        return data;// 补全资质需要立即返回值
      } catch (e) {
        commit(types.SET_CHARGE_INFO, {});
        return {};
      }
    },
    // 是否有支付权限
    async getChargeInfo({ commit }) {
      try {
        const { data } = await request.get(apis.payment.charge_info);
        commit(types.SET_HAS_GOT_CHARGE_INFO);
        commit(types.SET_CHARGE_INFO, data);
        return data;// 补全资质需要立即返回值
      } catch (e) {
        commit(types.SET_CHARGE_INFO, {});
        return {};
      }
    },

    async getIsUserPaymentStatus({ commit }, data = {}) {
      try {
        const resp = await request.get(apis.smb_support.get_payment_status, data) || {};
        const paymentStatus = (resp && resp.data) || {};
        commit(types.SET_PAYMENT_STATUS, paymentStatus);
        return paymentStatus;
      } catch (e) {
        commit(types.SET_PAYMENT_STATUS, {});
        return {};
      }
    },

    /**
     * 充值金额校验。注意这里的 data 里的 amount 是 number 类型的
     * @param {*} store
     * @param {Object} data
     * @returns
     */
    verifyReloadAmount(store, data) {
      return request.get(apis.payment.verifyReloadAmount, data);
    },

    // 获取充值税费试算
    getChargeTax(store, data) {
      return request.get(apis.payment.getChargeTax, data);
    },

    // 获取余额明细,RF还在用
    async getRfBalance({ commit }) {
      try {
        const { data } = await request.get(apis.payment.paymentBalance);
        commit(types.SET_PAYMENT_BALANCE, data);
      } catch (e) {
        commit(types.SET_PAYMENT_BALANCE, {});
      }
    },

    // 余额明细带税完整版
    async getPaymentTax({ commit }) {
      try {
        const { data } = await request.get(apis.payment.balance, {
          source: 3, // 3 代表tiktok竞价平台
        });
        commit(types.SET_PAYMENT_TAX, data);
        return data;
      } catch (e) {
        commit(types.SET_PAYMENT_TAX, {});
        return {};
      }
    },

    // 获取绑卡地址
    getCardBindLink(store, data) {
      const risk_info = tool.getRiskInfo();
      return request.post(apis.payment.getBindLink, { ...data, risk_info });// 获取绑卡地址
    },

    // 预付费调收银台支付
    submitPrepay(store, data) {
      return request.post(apis.payment.subPrePay, data);
    },
    // ---------------------- 自助授信相关 ----------------------//

    getCreditlineQuota({ commit }, data) {
      return request.get(apis.payment.get_creditline_quota, data);
    },

    increaseAmtBalance({ commit }, data) {
      return request.post(apis.payment.increase_amt_balance, data);
    },
    getDecreaseState({ commit }, data) {
      return request.get(apis.payment.get_decrease_state, data);
    },
    decreaseAmtBalance({ commit }, data) {
      return request.post(apis.payment.decrease_amt_balance, data);
    },
    getApplyCreditline({ commit }, data) {
      return request.get(apis.payment.apply_creditline, data);
    },
    async getApplyCreditlineForSelfServe({ commit }, data) {
      const info = await request.get(apis.payment.canApplyMonthlyInvoiceForSelfServe, data);
      commit(types.SET_PAYMENT_APPLYINFO, info.data || {});
      return info;
    },
    // ---------------------- 自助授信相关 ----------------------//

    getSharkPayment({ commit }, data) {
      const risk_info = tool.getRiskInfo();
      const event_name = 'ads_autopay_show';
      return request.post(apis.account.sharkPayment, {
        risk_info: { ...risk_info, duration: Date.now() - appInfoObect.duration },
        event_name,
      });
    },

    checkHistoryBill() {
      return request.get(apis.payment.checkHistoryBill);
    },
    getThreshold() {
      return request.get(apis.payment.threshold_info);
    },
    setThreshold(_, threshold) {
      return request.post(apis.payment.threshold_info, { manual_threshold: `${threshold}` });
    },
    thresholdSwitch() {
      return request.get(apis.payment.threshold_switch);
    },
    async getBillingShareBannerInfo({ commit, rootState }) {
      try {
        const res = await request.get(apis.payment.billing_share_banner, {
          ttam_account_id: rootState.account.aadvid,
        });
        commit(types.SET_BILLING_SHARE_BANNER, res?.data || {});
      // eslint-disable-next-line no-empty
      } catch (error) {}
    },
    setBillingSetting({ commit }, data) {
      commit(types.SET_BILLING_SETTING, data);
    },
    clearBillingShareBannerInfo({ commit, state }) {
      commit(types.SET_BILLING_SHARE_BANNER, {
        billing_sharing: state.billingShareBanner.billing_sharing,
      });
    },
    async getBillingOwnInfo({ commit, rootState }, data) {
      try {
        const res = await request.get(apis.payment.get_billing_owner, {
          ttam_account_id: rootState.account.aadvid,
          version: 1,
        });
        console.log('getBillingOwnInfo', res);
        commit(types.SET_BILLING_OWN_INFO, res?.data || {});
      // eslint-disable-next-line no-empty
      } catch (error) {}
    },
    setPaymentSummaryComponent({ commit }, fn) {
      commit(types.SET_PAYMENT_SUMMARY_RELOAD, fn);
    },
    setCreditInfoBillBalance({ commit, state }, billBalance) {
      commit(types.SET_CREDIT_INFO, {
        ...state.creditInfo,
        bill_balance: billBalance,
      });
    },
    async getBalanceOptimizationABTest({ commit }) {
      try {
        const res = await getAbVersion({
          ab_feature: 'ttam_balance_optimization',
        });
        const balanceOptimization = res?.ttam_balance_optimization || {
          new_version: false,
        };
        commit(types.SET_BALANCE_OPTIMIZATION, balanceOptimization);
      // eslint-disable-next-line no-empty
      } catch (error) {}
    },
  },
};
